import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { Collection } from "@/lib/api/types";

export const useCollections = () => {
  const { data: collections, isLoading, error, refetch } = useQuery({
    queryKey: ["collections"],
    queryFn: async (): Promise<Collection[]> => {
      console.log("Fetching collections (lightweight, no nested children)...");
      
      const { data, error } = await supabase
        .from("collections")
        .select(`
          *,
          product_descriptions(id, status),
          translations(id, status)
        `)
        .order("created_at", { ascending: false });

      if (error) {
        console.error("Error fetching collections:", error);
        throw error;
      }

      // Keep lightweight shape but include approval status data for dashboard filtering
      const safeCollections = (data || []).map((collection: any) => ({
        ...collection,
        product_descriptions: collection.product_descriptions || [],
        translations: collection.translations || [],
      })) as Collection[];

      console.log("Lightweight collections fetched:", safeCollections.length);
      return safeCollections;
    },
    // Less frequent polling and reasonable cache
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: false,
  });

  return {
    collections: collections || [],
    isLoading,
    error,
    refetch,
  };
};
